import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { SlideList } from "@/pages/admin/SlideList";

export default function AdminHomepage() {
  const [h, setH] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    api.get("/admin/homepage").then((r) => setH(r.data)).catch((e) => {
      toast.error(errMsg(e));
      setH({ slides: [], banners: [] });
    });
  }, []);
  if (!h) return <div className="h-60 animate-pulse rounded-2xl bg-white/5" />;

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/admin/homepage", { slides: h.slides, banners: h.banners });
      setH(data);
      toast.success("Homepage salvata");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-5xl space-y-10" data-testid="admin-homepage-page">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="font-display text-3xl font-semibold">Homepage e slide</h1>
          <p className="mt-1 text-sm text-slate-400">Modifica immagini, testi, pulsanti, ordine e visibilità. Le modifiche sono visibili dopo il salvataggio.</p>
        </div>
        <button onClick={save} disabled={saving} className="h-10 rounded-full bg-[#0066FF] px-6 text-sm font-medium disabled:opacity-50" data-testid="homepage-save-btn">
          {saving ? "Salvataggio…" : "Salva modifiche"}
        </button>
      </div>
      <SlideList title="Slider principale" kind="slide" items={h.slides} onChange={(slides) => setH({ ...h, slides })} />
      <SlideList title="Banner promozionali" kind="banner" items={h.banners} onChange={(banners) => setH({ ...h, banners })} />
    </div>
  );
}
